import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));

// Opt in to PWA when ready. See ./serviceWorker.js
serviceWorker.unregister();
